import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/Modals/LoginModal";
import { useAuth } from "../contexts/JWTContext";
import RegisterModal from "../components/Auth/RegisterModal";
import styles from "./Login.module.css";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [showRegister, setShowRegister] = useState(false);

  const openRegister = useCallback(() => {
    setShowRegister(true);
  }, []);

  const openLogin = useCallback(() => {
    setShowRegister(false);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className={styles.loginPage}>
      {!showRegister && (
        <LoginModal
          isOpen
          onClose={() => {}}
          onOpenRegister={openRegister}
          hideClose
        />
      )}
      {showRegister && (
        <RegisterModal
          onClose={openLogin}
          onSwitchToLogin={openLogin}
          hideClose
        />
      )}
    </div>
  );
};

export default Login;
